import { createThemedComponent } from './create-themed-component';
/**
 * `styled` is little more than a recreation of `createThemedComponent`, with a nicer API. It does the same thing, but looks a bit nicer to use and has a clean name 😇
 *
 * ```jsx
 * import { Text } from 'react-native'
 *
 * const MyText = styled(Text)({
 *   borderBottomStyle: 'solid',
 *   color: ['primary', 'secondary']
 * })
 * ```
 *
 */
export function styled(Component, { themeKey, defaultVariant, } = {}) {
    return function dripsyFactory(defaultStyle) {
        return createThemedComponent(Component, {
            defaultVariant,
            themeKey,
            defaultStyle,
        });
    };
}
//# sourceMappingURL=styled.js.map